module.exports = __webpack_public_path__ + "static/pechuga-rellena-de-pina-2-45415a90e438b32047f8cf9c7d1f4634.jpg";